import {
  DATE,
  SESSION_TYPES,
  DirectionTypes,
  DispositionTypes,
  IWebexCallHistoryResponse
} from '../../../adapter-interfaces/src';

/**
 * Mock call history service specifically for phone enrichment testing.
 * Returns a single call history item WITHOUT a name so DSS enrichment is triggered.
 * This is SEPARATE from WebexMockCallHistoryService - does not interfere with it.
 */

const now = Date.now();

function buildEnrichmentTestSession() {
  const start = new Date(now - 5 * 60 * 1000); // 5 minutes ago
  const end = new Date(start.getTime() + 120 * 1000); // 2 minute call

  return {
    id: 'enrichment-test-session-1',
    durationSecs: 120,
    self: {
      id: 'self-user',
      name: 'Self User',
      incomingCallProtocols: [],
      callbackInfo: {
        callbackAddress: '9999999999',
        callbackType: 'PHONE',
      },
    },
    url: 'https://example.com/call/enrichment-test',
    sessionId: 'enrichment-test-session-1',
    sessionType: SESSION_TYPES.WEBEXCALLING,
    startTime: start.toISOString(),
    endTime: end.toISOString(),
    direction: DirectionTypes.INCOMING,
    disposition: DispositionTypes.INITIATED,
    other: {
      id: 'contact-enrichment-test',
      name: '', // Empty name to trigger DSS enrichment
      phoneNumber: '9999999999',
      isPrivate: false,
      callbackAddress: 'sip:9999999999@example.com',
    },
    durationSeconds: 120,
    joinedDurationSeconds: 120,
    participantCount: 2,
    links: {
      locusUrl: 'https://example.com/locus/enrichment-test',
      callbackAddress: 'sip:9999999999@example.com',
    },
    isDeleted: false,
    isPMR: false,
    correlationIds: [],
    isRead: false,
  };
}

/**
 * Returns a single call history item for enrichment testing
 */
export async function getMockEnrichmentCallHistory(): Promise<IWebexCallHistoryResponse> {
  // Small delay to simulate API
  await new Promise((resolve) => setTimeout(resolve, 200));

  const session = buildEnrichmentTestSession();
  console.log('[Enrichment] Mock data generated:', {
    phoneNumber: session.other.phoneNumber,
    name: session.other.name,
    isEmpty: session.other.name === '',
    sessionId: session.id
  });

  return {
    statusCode: 200,
    message: 'Mock call history for phone enrichment testing (1 item without name)',
    data: {
      userSessions: [session],
    },
  };
}
